import React from 'react'
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';

const CustomAccordion = ({ title = '' ,children} ) => {
    return <Accordion>
        <AccordionSummary
            expandIcon={<ArrowDownwardIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
        >
            <Typography>{title}</Typography>
        </AccordionSummary>
        <AccordionDetails 
        // sx={{padding:'0px'}}
        >
            {children}
        </AccordionDetails>
    </Accordion>
}

export default CustomAccordion